import { TodosLayout } from "@/components/layouts/todos-layout";
import { useRoutePersistence } from "@/hooks/use-route-persistance";
import { useTenant } from "@/providers/session";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang",
)({
  component: ReceivableLayout,
});

function ReceivableLayout() {
  const { companySlug } = useTenant();

  useRoutePersistence(companySlug, "receivable");

  return (
    <TodosLayout type="receivable">
      <Outlet />
    </TodosLayout>
  );
}
